import { render, staticRenderFns } from "./completedJoborder.vue?vue&type=template&id=864cac2a"
import script from "./completedJoborder.vue?vue&type=script&lang=js"
export * from "./completedJoborder.vue?vue&type=script&lang=js"
import style0 from "./completedJoborder.vue?vue&type=style&index=0&id=864cac2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports